import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { RefreshCw } from 'lucide-react';

const ResetTripModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="reset-trip-modal" className="bg-card border-border max-w-sm">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <RefreshCw className="w-8 h-8 text-primary" />
            <DialogTitle className="text-2xl font-heading">Reset Trip Budget?</DialogTitle>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <p className="text-foreground">
            This will clear your trip settings and restart the onboarding process.
          </p>
          
          <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 space-y-2">
            <p className="text-sm font-semibold text-foreground">What will be cleared:</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Total budget</li>
              <li>• Trip duration</li>
              <li>• Daily budget</li>
              <li>• Destination</li>
            </ul>
          </div>

          <div className="bg-success/10 border border-success/20 rounded-lg p-4 space-y-2">
            <p className="text-sm font-semibold text-foreground">What will be kept:</p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• All your expenses</li>
              <li>• Expense history</li>
              <li>• Currency preferences</li>
            </ul>
          </div>

          <p className="text-xs text-muted-foreground">
            You'll be able to set up a new trip budget after resetting.
          </p>
        </div>

        <div className="flex gap-3 pt-2">
          <Button
            data-testid="cancel-reset-button"
            onClick={onClose}
            variant="outline"
            className="flex-1 rounded-full border-border"
          >
            Cancel
          </Button>
          <Button
            data-testid="confirm-reset-button"
            onClick={onConfirm}
            className="flex-1 rounded-full bg-primary text-primary-foreground"
          >
            Reset Trip
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResetTripModal;
